
import EDIconButton from '../../Buttons/IconButton/EDIconButton';
import { TextEditEndAdornment } from '../../TextEdit/EDTextEdit';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';

interface IProps {
  onClick?: () => void;
  disabled?: boolean;
  tooltip?: string | null;
  adornmentPadding?: CommonPropsAndTypes.ExpandedSpacingType;
}
export const DatePickerInputAdornment: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <TextEditEndAdornment>
      <EDIconButton
        disabled={props.disabled}
        iconColor="action"
        iconSize="medium"
        disableTabbing={true}
        margin="none"
        icon="event"
        tooltip={'Välj ' + (props.tooltip ?? 'datum')}
        tooltipInAriaLabelOnly
        padding={props.adornmentPadding ?? 'dense'}
        onClick={props.onClick}
      />
    </TextEditEndAdornment>
  );
};
